import './App.css';
import Main from './containers/Main';
import Login from './components/Auth/Login'
import { Switch, Route } from 'react-router-dom'
import BackToTop from 'react-back-to-top-button'
import SingeArticle from "./components/Article/SingeArticle";
import { HomeDossier,HomeProfile } from './components/Home/Home';

function App({ props }) {
  return (
    <div className="App">
      <BackToTop
        showOnScrollUp
        showAt={100}
        speed={1500}
        easing="easeInOutQuint"
        style={{ zIndex: 100, backgroundColor: '#DCE4FF' }}
      >
        <span className={"top__back"}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" /></svg>
        </span>
      </BackToTop>

      <Switch>
        <Route exact path='/'>
          <Main />
        </Route>
        <Route path='/login'>
          <Login />
        </Route>
        <Route path={'/home/dossiers'}>
          <HomeDossier />
        </Route>
        <Route path={'/home/compte'}>
          <HomeProfile />
        </Route>
        <Route path={'/service/:service_id'}>
          <SingeArticle />
        </Route>
      </Switch>

    </div>
  );
}

export default App;
